export default {
    cn: {
        downloadReport: {
            previous: '上一级目录',
            tableHead: {
                file: '文件',
                handle: '操作'
            },
            download: '下载',
            open: '打开'
        }
    },
    hk: {
        downloadReport: {
            previous: '上一級目錄',
            tableHead: {
                file: '文件',
                handle: '操作'
            },
            download: '下載',
            open: '打開'
        }
    },
    en: {
        downloadReport: {
            previous: 'Privious Directory',
            tableHead: {
                file: 'File',
                handle: 'Handle'
            },
            download: 'Download',
            open: 'Open'
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/downloadReport.js